/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/18
 */
import React from 'react';

const Close = () => {
  return <svg className="store-svg-close" viewBox="0 0 1024 1024">
    <path d="M632.89344 512l353.44384-344.04864c33.37216-32.4864 34.09408-85.86752 1.60256-119.2448-32.45568-33.3568-85.84192-34.10432-119.23968-1.60256L512 394.32192 155.30496 47.104c-33.36704-32.4864-86.75328-31.7696-119.2448 1.60256-32.49152 33.37728-31.77472 86.7584 1.60256 119.2448L391.10656 512 37.66272 856.04864c-33.37728 32.48128-34.09408 85.87264-1.60256 119.23968 16.52736 16.98304 38.46656 25.50784 60.42624 25.50784 21.20192 0 42.42432-7.95136 58.81344-23.90528L512 629.6832l356.70016 347.20768c16.39424 15.96416 37.6064 23.90528 58.80832 23.90528 21.95456 0 43.90912-8.53504 60.43136-25.50784 32.49664-33.36704 31.7696-86.7584-1.60256-119.23968L632.89344 512z"/>
  </svg>
};

export default Close;



// WEBPACK FOOTER //
// ./src/svgs/close.js